module.exports = __webpack_public_path__ + "images/banners/estimate/progress/progress_banner_pc_5026fb0864d2925c37dae9c1cea8057f.png";